module.exports = __webpack_public_path__ + "static/media/trains-icon.e97fbb19.PNG";